// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../../fetch.pb.js";
export const CommandsService = {
    UpdateStripeAccountPayoutStatus(fn, req) {
        try {
            fm.validateUrlParam(req["stripeAccountId"], "stripeAccountId");
            fm.validateUrlParam(req["enablePayouts"], "enablePayouts");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/payments/commands/service/account/${req["stripeAccountId"]}/enable-payouts/${req["enablePayouts"]}`, { method: "PATCH", body: JSON.stringify(req, fm.replacer) });
    },
    UpdateStripeAccountPaymentStatus(fn, req) {
        try {
            fm.validateUrlParam(req["stripeAccountId"], "stripeAccountId");
            fm.validateUrlParam(req["enablePayments"], "enablePayments");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/payments/commands/service/account/${req["stripeAccountId"]}/enable-payments/${req["enablePayments"]}`, { method: "PATCH", body: JSON.stringify(req, fm.replacer) });
    },
    GetUnrecordedPaymentsCount(fn, req) {
        return fn(`/payments/commands/service/payments/unrecorded:count?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * CreatePaymentMethodCheckoutSessionLink will create a checkout session link
     * that will be sent to customer to save there ACH on file.
     */
    CreatePaymentMethodRegistrationLink(fn, req) {
        try {
            fm.validateUrlParam(req["personId"], "personId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/payments/commands/service/person/${req["personId"]}/paymentMethods/registration:link`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * ValidateACHTransactionBalance will get the financial connections
     * account and validate the balance present in the bank account.
     */
    ValidateACHTransactionBalance(fn, req) {
        return fn(`/payments/commands/service/paymentMethods/ach/transaction:balance`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     *  GetPatientBalances will get the balances from pms for all the patients
     * associated with the requested locations.
     */
    GetPatientsBalance(fn, req) {
        return fn(`/payments/commands/service/patients-balance?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * BatchCreateBalancesPaymentRequests will create payment requests for the patients provided
     * in the request. If the list of patients is empty, the request will be created for all the patient balances
     * associated with the locations provided in the request.
     * The list of successful and failed payment requests will be returned in the response.
     */
    BatchCreateBalancesPaymentRequests(fn, req) {
        return fn(`/payments/commands/service/patients-balance/payment-request/batch:create`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
};
